<script>
import DataViewListVue from '@/app/arch/components/dataView/DataViewList.vue';
import ClientTypePersonVue from 'Modules/contacard/analysisTable/components/columns/ClientTypePerson.vue';
import ClientAnalysisStepVue from 'Modules/contacard/analysisTable/components/columns/ClientAnalysisStep.vue';

export default {
  name: 'ClientDataRegisterView',
  extends: DataViewListVue,
  data: () => ({
    content: [
      {
        text: 'Tipo de pessoa',
        value: 'clientType',
        component: ClientTypePersonVue,
      },
      {
        text: 'Passo de cadastro',
        value: 'clientStep',
        component: ClientAnalysisStepVue,
      },
    ],
  }),
};
</script>
